<template>
  <div class="bg-blue-500 text-white p-2 mt-auto text-center">
    <p>Pour me contacter: heu ben non - finalement on ne me contacte pas pour le moment;) </p>
  </div>
</template>

<script>
export default {
  name: 'FooterComponent',
}
</script>

<style>
</style>

